import { ButtonBS, ButtonBSProps } from "@biblioteksentralen/react";
import { useRediaPlatformContext } from "../../../rediaPlatform/RediaPlatformProvider";
import { useTranslation } from "../../../utils/hooks/useTranslation";
import { useSearchConfig } from "../../hooks/useSearchConfig";

type Props = {
  openFindInLibraryModal: () => void;
} & ButtonBSProps;

const FindInLibraryButton = ({ openFindInLibraryModal, ...buttonProps }: Props) => {
  const { t } = useTranslation();
  const { isSearchIntegrationEnabled } = useSearchConfig();
  const { rediaPlatformIsEnabled } = useRediaPlatformContext();

  if (!isSearchIntegrationEnabled || !rediaPlatformIsEnabled) return null;

  return (
    <ButtonBS {...buttonProps} onClick={openFindInLibraryModal}>
      {t("Finn i biblioteket")}
    </ButtonBS>
  );
};

export default FindInLibraryButton;
